var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUngroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16H6C4.89543 16 4 15.1046 4 14V6C4 4.89543 4.89543 4 6 4H14C15.1046 4 16 4.89543 16 6V8",
    stroke: "#292929",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 12,
    height: 12,
    rx: 2,
    stroke: "#292929",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 2,
    width: 3,
    height: 3,
    rx: 1.5,
    fill: "#292929"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 6,
    width: 3,
    height: 3,
    rx: 1.5,
    fill: "#292929"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 3,
    height: 3,
    rx: 1.5,
    fill: "#292929"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 19,
    width: 3,
    height: 3,
    rx: 1.5,
    fill: "#292929"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 19,
    width: 3,
    height: 3,
    rx: 1.5,
    fill: "#292929"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 3,
    height: 3,
    rx: 1.5,
    fill: "#292929"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 15,
    width: 3,
    height: 3,
    rx: 1.5,
    fill: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUngroup);
export default __webpack_public_path__ + "static/media/ungroup.98bbe41a.svg";
export { ForwardRef as ReactComponent };